const SourceLibrary = Object.freeze({
    FROM_SCHOOL_LIBRARY: 'FROM_SCHOOL_LIBRARY',
    FROM_B4S_LIBRARY: 'FROM_B4S_LIBRARY',
    FROM_AI_LIBRARY: 'FROM_AI_LIBRARY',
    FROM_QS_BANK: 'FROM_QS_BANK',
});

export default SourceLibrary